angular.module('bmsApp.reports')
	.controller('ReportIndexCtrl', [
		'$state',
		'$scope',
		'$q',
		'notify',
		'$window',
		'EmployeeOptionsSvc',
		'LicenseOptionsSvc',
		'ReportSvc',
		function ($state,
				  $scope,
				  $q,
				  notify,
				  $window,
				  EmployeeOptionsSvc,
				  LicenseOptionsSvc,
				  ReportSvc) {


			var self = this;

			// The currently selected report
			self.selectedReport = null;

			self.processing = false;

			self.dateRangeConfig = angular.copy($scope.config.datePicker.range);
			self.monthRangeConfig = angular.copy($scope.config.datePicker.monthRange);
			self.dateConfig = angular.copy($scope.config.datePicker.basic);

			self.options = {};

			self.methods = {
				init: _init,
				hasFilter: _hasFilter,
				requiresFilter: _requiresFilter,
				selectReport: _selectReport,
				runReport: _runReport,
				export: _export
			};

			self.form = {
				validator: {
					config: {},
					api: {}
				},
				promise: undefined
			};

			function _init() {
				var promises = {
					employee: EmployeeOptionsSvc.employee(),
					license: LicenseOptionsSvc.license()
				};
				$q.all(promises)
					.then(function (responses) {
						self.options.employees = responses.employee.data.options;
						self.options.licenses = responses.license.data.options;

						generateDates();
						generateStatuses();
						populateReports();
					});
			}

			function generateStatuses() {
				self.options.customerStatuses = [
					{
						value: 3,
						label: 'Active'
					},
					{
						value: 2,
						label: 'Prospect'
					},
					{
						value: 1,
						label: 'Pending'
					},
					{
						value: 4,
						label: 'Inactive'
					}
				];
			}

			function generateDates() {
				var today = moment.utc();

				// Single year (back 5 years)
				self.options.singleYear = [
					{
						id: 0,
						label: today.format('Y')
					}
				];
				for (var i = 1; i < 6; i++) {
					self.options.singleYear.push({
						id: i,
						label: today.subtract(1, 'years')
							.format('Y')
					});
				}

				// Weeks
				self.options.week = [];
				var endOfYear = moment.utc()
					.endOf('year')
					.endOf('week');
				var week = moment.utc()
					.startOf('year')
					.startOf('week');
				var i = 0;
				while (week.isSameOrBefore(endOfYear)) {
					var weekCopy = angular.copy(week);
					self.options.week.push({
						id: i,
						label: weekCopy.format('Do MMM') + ' (Week ' + weekCopy.format('w') + ')',
						date: weekCopy
					});
					week.add(1, 'weeks');
					i++;
				}

				// Weeks (no overflow)
				self.options.weekNoOverflow = [];
				var endOfYearNoOverflow = moment.utc()
					.endOf('year');
				var weekNoOverflow = moment.utc()
					.isoWeek(1)
					.startOf('week');
				var i = 0;
				while (weekNoOverflow.isSameOrBefore(endOfYearNoOverflow)) {
					var weekCopyNoOverflow = angular.copy(weekNoOverflow);
					self.options.weekNoOverflow.push({
						id: i,
						label: weekCopyNoOverflow.format('Do MMM') + ' (Week ' + weekCopyNoOverflow.format('w') + ')',
						date: weekCopyNoOverflow
					});
					weekNoOverflow.add(1, 'weeks');
					i++;
				}

				// Year comparison
				self.options.comparisonYears = [
					{
						value: 1,
						label: 'Current year only'
					},
					{
						value: 2,
						label: '+1'
					},
					{
						value: 3,
						label: '+2'
					},
					{
						value: 4,
						label: '+3'
					},
					{
						value: 5,
						label: '+4'
					},
					{
						value: 6,
						label: '+5'
					}
				];
			}

			function _hasFilter(filter) {
				if (angular.isDefined(self.selectedReport)) {
					return self.selectedReport.filters.indexOf(filter) !== -1;
				}
			}

			function _requiresFilter(filter) {
				if (angular.isDefined(self.selectedReport) && angular.isDefined(self.selectedReport.filtersRequired)) {
					return self.selectedReport.filtersRequired.indexOf(filter) !== -1;
				}
				else {
					return false;
				}
			}

			function _selectReport(report) {
				self.selectedReport = report;
				if (_hasFilter('date_range') && angular.isUndefined(self.selectedReport.appliedFilters['dateRange'])) {
					angular.extend(self.selectedReport.appliedFilters, {
						dateRange: {
							startDate: moment().startOf('month'),
							endDate: moment().endOf('month'),
						}
					});
				}
				else if (_hasFilter('single_date') && angular.isUndefined(self.selectedReport.appliedFilters['single_date'])) {
					angular.extend(self.selectedReport.appliedFilters, {
						single_date: moment().startOf('day'),
					});
				}

				if (_hasFilter('date_range') && (angular.isDefined(self.selectedReport.filterConfig))) {
					if(self.selectedReport.filterConfig.dateRange.disablePast){
						delete self.dateRangeConfig.options.ranges;
						self.dateRangeConfig.options.minDate = moment().startOf('day');
						self.dateRangeConfig.options.maxDate = moment().add(10,'years').endOf('day');
						angular.extend(self.dateRangeConfig.options, {
							minDate: moment().startOf('day'),
							maxDate: moment().add(10,'years').endOf('day')
						});

						angular.extend(self.selectedReport.appliedFilters, {
							dateRange: {
								startDate: self.dateRangeConfig.options.minDate,
								endDate: moment().endOf('month'),
							}
						});

					}
				} else {
					self.dateRangeConfig = angular.copy($scope.config.datePicker.range);
					delete self.dateRangeConfig.options.minDate;
					delete self.dateRangeConfig.options.maxDate;
				}


				if (_hasFilter('license') && self.options.licenses.length === 1) {
					angular.extend(self.selectedReport.appliedFilters, {
						license: self.options.licenses[0],
					});
				}


			}

			function _runReport(exportToCSV) {
				if (self.form.validator.api.valid()) {
					if (angular.isDefined(self.selectedReport)) {
						angular.extend(self.selectedReport, {
							export: angular.isUndefined(exportToCSV) ? false : true
						});
						self.form.promise = ReportSvc.run(self.selectedReport)
							.then(function (response) {
								if (exportToCSV) {
									$window.open(response.data.baseFilename.url, '_blank');
								}
								else {
									angular.extend(self.selectedReport, {
										reportData: response.data.report_data,
										additionalData: response.data.additional_data
									});
								}
							}, function (errors) {
								$scope.errors = errors;
							});
					}
				}
			}

			function _export() {
				_runReport(true);
			}

			function populateReports() {
				self.filters = {
					license: 'license',
					week_range: 'week_range',
					week_range_no_overflow: 'week_range_no_overflow',
					date_range: 'date_range',
					month_year_range: 'month_year_range',
					single_date: 'single_date',
					single_year: 'single_year',
					comparison_years: 'comparison_years',
					employee: 'employee',
					customer_status: 'customer_status',
				};

				self.reportTypes = {
					csv: 'csv',
					custom: 'custom'
				};

				// Shared reports
				self.reports = {
					module: {
						crm_marketing: [
							{
								name: 'Customers by postcode',
								value: 'customers_by_postcode',
								type: self.reportTypes.csv,
								description: 'A count of customers grouped by postcode sector',
								filters: [
									self.filters.customer_status,
								],
								appliedFilters: {
									customer_status: [],
								}
							},
							{
								name: 'Customer status revenue',
								value: 'customer_status_revenue',
								type: self.reportTypes.csv,
								description: 'Customer status wise count and revenue for a date period',
								filters: [
									self.filters.license,
									self.filters.date_range,
								],
								appliedFilters: {}
							},
						],
						work: [],
						employee: [
							{
								name: 'Employee Attendance',
								value: 'employee_attendance',
								type: self.reportTypes.custom,
								view: 'EmployeeAttendance.html',
								description: 'Time and attendance - by employee for a date period',
								filters: [
									self.filters.week_range
								],
								appliedFilters: {}
							}
						],
						accounting: [
							{
								name: 'Customer Balances Report',
								description: 'A list of all active customers and their balance',
								value: 'customer_balances',
								type: self.reportTypes.csv,
								filters: [
									self.filters.single_date,
								],
								filtersRequired: [
									self.filters.single_date,
								],
								appliedFilters: {}
							},
							{
								name: 'Annual Revenue Comparison',
								value: 'annaul_revenue_comparison',
								type: self.reportTypes.custom,
								view: 'AnnualRevenueComparison.html',
								description: 'Annual Revenue Comparison',
								filters: [
									self.filters.license,
									self.filters.date_range
								],
								appliedFilters: {}

							}
						]
					}
				};

				if ($scope.isSM() || $scope.isMM()){
					self.reports.module.work.push({
						name: 'E-com Job Report',
						value: 'ecom_job_report',
						type: self.reportTypes.csv,
						description: 'Displays a list of e-commerce jobs between two dates',
						filters: [
							self.filters.license,
							self.filters.date_range
						],
						filtersRequired: [
							self.filters.date_range
						],
						appliedFilters: {}
					});
				}

				if ($scope.isSM() || $scope.isMM()){
					self.reports.module.work.push({
						name: 'Daily Technician Mobile Breakdown',
						value: 'daily_technician_mobile_breakdown',
						type: self.reportTypes.csv,
						description: 'Displays a list of daily technician mobile breakdown',
						filters: [
							self.filters.date_range
						],
						filtersRequired: [
							self.filters.date_range
						],
						appliedFilters: {}
					});
				}

				if ($scope.isMM()) {
					// WORK REPORTS
					self.reports.module.work.push({
						name: 'Cancelled Jobs',
						value: 'mm_cancelled_jobs',
						type: self.reportTypes.csv,
						description: 'Displays a list of cancelled jobs between two dates',
						filters: [
							self.filters.license,
							self.filters.date_range
						],
						filtersRequired: [
							self.filters.date_range
						],
						appliedFilters: {}
					});

					self.reports.module.work.push({
						name: 'Daily Closeout Summary',
						value: 'mm_daily_closeout_summary',
						type: self.reportTypes.csv,
						description: 'For a particular day it will detail specific information on how many cleans completed, how many cancelled and payments received',
						filters: [
							self.filters.license,
							self.filters.single_date
						],
						appliedFilters: {}
					});

					// EMPLOYEE REPORTS
					self.reports.module.employee.push({
						name: 'Holiday Breakdown',
						value: 'employee_holiday_breakdown',
						type: self.reportTypes.custom,
						view: 'EmployeeHolidayBreakdown.html',
						description: 'A list of employees with their holiday information past and present',
						filters: [
							self.filters.single_year,
							self.filters.employee
						],
						appliedFilters: {}
					});

					// ACCOUNTING REPORTS
					self.reports.module.accounting.push({
						name: 'Income forecast',
						value: 'mm_income_forecast',
						type: self.reportTypes.csv,
						description: 'Forecast income between two dates in the future',
						filters: [
							self.filters.license,
							self.filters.date_range
						],
						filtersRequired: [
							self.filters.date_range
						],
						appliedFilters: {}
					});
					self.reports.module.accounting.push({
						name: 'Payroll',
						value: 'mm_payroll',
						type: self.reportTypes.csv,
						description: 'Payroll overview for each employee between two dates',
						filters: [
							self.filters.date_range
						],
						appliedFilters: {}
					});
					self.reports.module.accounting.push({
						name: 'Payroll By Employee',
						value: 'payroll_by_employee',
						type: self.reportTypes.custom,
						view: 'PayrollByEmployee.html',
						description: 'Displays a more detailed breakdown of payroll by employee and day, between two dates',
						filters: [
							self.filters.date_range,
							self.filters.employee
						],
						appliedFilters: {}
					});
					self.reports.module.accounting.push({
						name: 'Cash Collected',
						value: 'mm_cash_collected',
						type: self.reportTypes.custom,
						view: 'MmCashCollected.html',
						description: 'Displays all physical cash that has been collected for which customers between two dates',
						filters: [
							self.filters.license,
							self.filters.date_range
						],
						appliedFilters: {}
					});
					self.reports.module.accounting.push({
						name: 'Weekly Income',
						value: 'mm_weekly_income',
						type: self.reportTypes.custom,
						view: 'MmWeeklyIncome.html',
						description: 'Forecasts your next 5 weeks income and gives a comparison of that of another 5 weeks in the past that you provide',
						filters: [
							self.filters.license,
							self.filters.week_range_no_overflow
						],
						filtersRequired: [
							self.filters.week_range_no_overflow
						],
						appliedFilters: {}
					});
					self.reports.module.accounting.push({
						name: 'Weekly Frequency Revenue',
						value: 'mm_weekly_frequency_revenue',
						type: self.reportTypes.custom,
						view: 'MmWeeklyFrequencyRevenue.html',
						description: 'Gives a breakdown per frequency of revenue and growth compared to that of a previous year in the same period',
						filters: [
							self.filters.license,
							self.filters.week_range_no_overflow,
							self.filters.comparison_years
						],
						appliedFilters: {}
					});
					self.reports.module.accounting.push({
						name: 'Earnings Per Interval',
						value: 'mm_earnings_per_interval',
						type: self.reportTypes.csv,
						description: 'Display earnings per interval - by job',
						filters: [
							self.filters.license,
							self.filters.date_range
						],
						appliedFilters: {}
					});
					self.reports.module.accounting.push({
						name: 'Earnings Per Interval - By Customer',
						value: 'mm_earnings_per_interval_by_customer',
						type: self.reportTypes.csv,
						description: 'Display earnings per interval - by customer',
						filters: [
							self.filters.license,
							self.filters.date_range
						],
						appliedFilters: {}
					});
					self.reports.module.accounting.push({
						name: 'Average fee by frequency',
						value: 'mm_avg_fee_by_frequency',
						type: self.reportTypes.csv,
						description: 'Average invoiced fee broken down by frequency type',
						filters: [
							self.filters.license,
							self.filters.date_range
						],
						appliedFilters: {}
					});


					// CUSTOMER & MARKETING REPORT
					self.reports.module.crm_marketing.push({
						name: 'New Customers',
						value: 'new_customers',
						type: self.reportTypes.csv,
						description: 'Lists new customers for a date period',
						filters: [
							self.filters.date_range
						],
						appliedFilters: {}
					});
					self.reports.module.crm_marketing.push({
						name: 'Customer Keys',
						value: 'customer_keys',
						type: self.reportTypes.csv,
						description: 'View all key numbers associated with each customer',
						filters: [
							self.filters.customer_status,
						],
						appliedFilters: {
							customer_status: [],
						}
					});
					// self.reports.module.crm_marketing.push({
					// 	name: 'Marketing Metrics',
					// 	value: 'marketing_metrics',
					// 	type: self.reportTypes.csv,
					// 	description: 'Displays a breakdown of all marketing activity and details enquiries converted, jobs won etc.',
					// 	filters: [
					// 		self.filters.license,
					// 		self.filters.date_range
					// 	],
					// 	appliedFilters: {}
					// });
				}
				else if ($scope.isSM()) {
					self.reports.module.crm_marketing.push({
						name: 'Residential Marketing and Revenue Report',
						description: 'Provides metric information on marketing and revenue for enquiries and active jobs within a date period',
						value: 'sm_enquiry_performance',
						type: self.reportTypes.csv,
						filters: [
							self.filters.date_range
						],
						appliedFilters: {}
					});
				}
				else if ($scope.isTG()) {
					self.reports.module.work.push({
						name: 'Chemical Application Record',
						value: 'chemical_record',
						type: self.reportTypes.csv,
						description: 'Displays chemical application records',
						filters: [
							self.filters.license,
							self.filters.date_range
						],
						appliedFilters: {}
					});
					self.reports.module.work.push({
						name: 'Inventory Report',
						value: 'inventory_report',
						type: self.reportTypes.csv,
						description: 'Displays inventory with stock levels',
						filters: [
							self.filters.date_range,
						],
						appliedFilters: {
							dateRange: {
								startDate: moment().startOf('day'),
								endDate: moment().add(19, 'day'),
							},
						}
					});

					self.reports.module.work.push({
						name: 'Average lawn size by postcode',
						value: 'average_lawn_size_report',
						type: self.reportTypes.csv,
						description: 'Displays average lawn size by postcode',
						filters: [
							self.filters.postcode_district,
						],
						filtersRequired: [],
						appliedFilters: {}
					});

					self.reports.module.work.push({
						name: 'Spend per customer',
						value: 'tg_spend_per_customer_report',
						type: self.reportTypes.csv,
						description: 'Displays amount spend per customer in a postcode district',
						filters: [
							self.filters.postcode_district,
						],
						filtersRequired: [
							self.filters.postcode_district,
						],
						appliedFilters: {}
					});

					self.reports.module.accounting.push({
						name: 'Forecast Revenue',
						value: 'tg_forecast_revenue',
						type: self.reportTypes.csv,
						description: 'Shows forecasted revenue between a date range',
						filters: [
							self.filters.license,
							self.filters.date_range
						],
						filterConfig:{
							dateRange: {
								disablePast: true
							}
						},
						appliedFilters: {}
					});

					self.reports.module.work.push({
						name: 'Last and upcoming treatment Report',
						value: 'tg_last_and_upcoming_treatment',
						type: self.reportTypes.csv,
						description: 'By customer and site, view the last and upcoming of selected treatments.',
						filters: [
							self.filters.customer_status,
						],
						appliedFilters: {}
					});

					self.reports.module.work.push({
						name: 'Customer retention report',
						value: 'customer_retention_report',
						type: self.reportTypes.custom,
						view: 'CustomerRetentionReport.html',
						description: 'Customer retention between two dates',
						filters: [
							self.filters.month_year_range,
						],
						filtersRequired: [
							self.filters.month_year_range
						],
						appliedFilters: {}
					});
					self.reports.module.crm_marketing.push({
						name: 'New Customers',
						value: 'new_customers',
						type: self.reportTypes.csv,
						description: 'Lists new customers for a date period',
						filters: [
							self.filters.date_range
						],
						appliedFilters: {}
					});
				}

				if ($scope.isMM() || $scope.isTG()) {
					self.reports.module.crm_marketing.push({
						name: 'Lost Customers Report',
						value: 'inactive_customer_report',
						type: self.reportTypes.csv,
						description: 'Lists lost customers for a date period',
						filters: [
							self.filters.date_range
						],
						appliedFilters: {}
					});
				}
			}
		}
	]);
